import { useForm, type UseFormReturn } from '@kanda-libs/ks-component-ts';
import { StringIndexedObject } from '@kanda-libs/ks-design-library';
import { useCallback, useEffect, useRef } from 'react';
import {
  FinanceCalculatorFormValues,
  useFinanceCalculatorContext,
} from './context';

export interface FinanceCalculatorFormHook {
  form: UseFormReturn<FinanceCalculatorFormValues>;
  onSubmit: (
    formValues: StringIndexedObject<FinanceCalculatorFormValues>,
  ) => void;
}

export default function useFinanceCalculatorForm(): FinanceCalculatorFormHook {
  const { stored, setStored, initialValue } = useFinanceCalculatorContext();

  const form = useForm<FinanceCalculatorFormValues>({
    mode: 'onBlur',
    reValidateMode: 'onBlur',
    defaultValues: {
      type: 'monthlyPayments',
      amountToBorrow: initialValue,
    },
  });

  const onSubmit = useCallback(
    (formValues: StringIndexedObject<FinanceCalculatorFormValues>) => {
      const { type, ...rest } =
        formValues as unknown as FinanceCalculatorFormValues;
      setStored({
        ...stored,
        ...rest,
      });
    },
    [stored, setStored],
  );

  const initialValueRef = useRef<number>(initialValue);
  useEffect(() => {
    if (initialValue === initialValueRef.current) return;
    initialValueRef.current = initialValue;
    form.setValue('type', 'monthlyPayments');
    form.setValue('amountToBorrow', initialValue);
  }, [initialValue, form]);

  return {
    form,
    onSubmit,
  };
}
